import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { GoogleLogin, GoogleLoginResponse } from 'react-google-login';
import { AppState, AuthState, UserInfo } from 'src/store';
import { replace as replaceAction } from 'react-router-redux';
import { RouteComponentProps } from 'react-router';
import { Dispatch, connect } from 'react-redux';
import { actions as toastActions, Toast } from 'src/toast';
import { actions } from '../redux';
import * as React from 'react';
import * as firebase from 'firebase/app';

import bg from './bg.jpg';
import logo from './app-logo.png';
import { gauthAsync } from 'src/api';
import { Button } from 'antd';
import { Unsubscribe } from 'firebase/app';
const locationHelper = locationHelperBuilder({});
const clientId = process.env.REACT_APP_GOOGLE_CREDENTIALS_CLIENT_ID || '';

const mapStateToProps = ({ authState }: AppState, ownProps: RouteComponentProps<{}>) => {
  const redirect = locationHelper.getRedirectQueryParam(ownProps) || '/';

  return {
    authState,
    redirect
  };
};
const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    replace: (route: string) => {
      dispatch(replaceAction(route));
    },
    loggingIn: () => {
      dispatch(actions.loggingIn());
    },
    loggedIn: (userInfo: UserInfo) => {
      dispatch(actions.loggedIn(userInfo));
    },
    error: (content: React.ReactNode) => {
      dispatch(toastActions.error(content));
    }
  };
};

interface Props extends RouteComponentProps<{}> {
  authState: AuthState;
  redirect: string;

  replace: (route: string) => void;
  loggingIn: () => void;
  loggedIn: (userInfo: UserInfo) => void;
  error: (content: React.ReactNode) => void;
}

class SignIn extends React.Component<Props, {}> {
  unsub: Unsubscribe;

  componentDidMount() {
    const { loggedIn, replace, redirect } = this.props;
    this.unsub = firebase.auth().onAuthStateChanged(async uinfo => {
      if (uinfo) {
        const token = await uinfo.getIdToken();
        loggedIn({ userId: uinfo.uid, token });
        replace(redirect);
      }
    });
  }

  componentWillUnmount() {
    if (this.unsub) {
      this.unsub();
    }
  }

  handleGLoginSuccess = async (response: GoogleLoginResponse) => {
    const { loggingIn, loggedIn, error, replace, redirect } = this.props;
    loggingIn();
    const r = await gauthAsync(response.getAuthResponse().id_token);
    if (!r.success) {
      error(
        <React.Fragment>
          <span>Login with </span>
          <strong>datafocus.cloud</strong>
          <span> account <a href="https://accounts.google.com">here</a></span>
        </React.Fragment>
      );
    } else if (r.token && r.userId) {
      const fsResult = await firebase.auth().signInWithCustomToken(r.token);
      // tslint:disable-next-line:no-console
      console.log('firebase result: ', fsResult);
      loggedIn({ userId: r.userId, token: r.token });
      replace(redirect);
    }
  }

  // tslint:disable-next-line:no-any
  handleGLoginError = (err: any) => {
    const { error } = this.props;
    error(err.details);
  }

  renderButton = (props?: { onClick: () => void }) => {
    const { authState } = this.props;
    return (
      <Button
        loading={authState.status === 'loading'}
        type="primary"
        icon="google"
        {...props}
      >
        Sign In
      </Button>);
  }

  render() {
    return (
      <div className="App">
        <Toast />
        <div className="login" style={{ backgroundImage: `url(${bg})` }}>
          <div className="box">
            <img src={logo} />
            <GoogleLogin
              clientId={clientId}
              hostedDomain="datafocus.cloud"
              buttonText="Sign In"
              onSuccess={this.handleGLoginSuccess}
              onFailure={this.handleGLoginError}
              render={this.renderButton}
            />
          </div>
        </div>
      </div>
    );

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);



// WEBPACK FOOTER //
// ./src/auth/containers/GLogin.tsx